
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/indicacao",
      function () {
        return require("private-next-pages/indicacao.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/indicacao"])
      });
    }
  